import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "For further information on OEM projects and bulk orders, please email us at ",
    reply2:
      " and our global Sales Team will attend to your specific inquiry at the soonest possible.",
    back: "Back",
  },
  ja: {
    reply1: "OEM プロジェクトや大量注文の詳細については、",
    reply2:
      " まで電子メールでお問い合わせください。当社のグローバル営業チームが、お客様の具体的なお問い合わせにできるだけ早く対応いたします。",
    back: "戻る",
  },
  es: {
    reply1:
      "Para obtener más información sobre proyectos OEM y pedidos al por mayor, envíenos un correo electrónico a ",
    reply2:
      " y nuestro equipo de ventas global atenderá su consulta específica lo antes posible.",
    back: "Atrás",
  },
});

class Q19_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;
    const email = "info@egeetouch.com";
    const mailtoLink = `mailto:${email}`;

    return (
      <div>
        {localizationStrings.reply1}
        <a
          href={mailtoLink}
          style={{ textDecoration: "underline", color: "black" }}
        >
          info@egeetouch.com
        </a>
        {localizationStrings.reply2}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q19_component;
